import { restPost } from "apiCommandsExecutor/rest";

import { SignInCodeSentDto, TokenPairDto } from "./restModels";
import {
    SignInCodeRequestDto,
    SignInWithCodeRequestDto,
    SignInWithPasswordRequestDto,
} from "./restRequests";

export const requestSignInCode = (body: SignInCodeRequestDto) =>
    restPost<SignInCodeSentDto>("/auth/sign-in/code", body);

export const signInWithCode = (body: SignInWithCodeRequestDto) =>
    restPost<TokenPairDto>("/auth/sign-in/code/verify", body);

export const signInWithPassword = (body: SignInWithPasswordRequestDto) =>
    restPost<TokenPairDto>("/auth/sign-in/password", body);
